// extracted by mini-css-extract-plugin
export var border_bottom = "imgCollection-module--border_bottom--4WSDL";
export var img_collection = "imgCollection-module--img_collection--dRsLI";